import { http } from '../../config/axios'

 const graficoConsumo = (): Promise<any> => {
  
  return http
    .get('api/consumo/grafico')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro graficoConsumo', error)
      throw Error(error.response.data)
    })
}

export default graficoConsumo;
